import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { WEB_LINKS, isRenault } from '../util/constants'
// MUI
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'

// Api Requests
import { createAppointment } from './../services/index'

// Redux Actions
import { showError } from './../redux/snackbar'
import { nextStep, previousStep } from './../redux/step'
import { setCustomerInfo } from './../redux/form'
import { setLoading } from './../redux/loading'
import { setAppointment } from './../redux/appointment'

// Custom
import PhoneInput from './../components/PhoneInput'
import CustomTextField from './../components/CustomTextField'
import CustomCard from './../components/CustomCard'
import CustomFormLabel from '../components/CustomFormLabel'
import { useTheme } from '@emotion/react';




// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }

function FunctionalComponent(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const form = useSelector(state => state.form)
    const portLogin = useSelector(state => state.portLogin)
    const utmValues = useSelector(state => state.utmValues)
    const vehicle = useSelector(state => state.vehicle)
    const loading = useSelector(state => state.loading)
    const theme = useTheme();

    // Styles
    const styles = {
        formRoot: {
            width: '100%'
        },
        checkboxChecked: {
            color: theme.palette.success.main,
        },
        link: {
            // textDecorationColor: theme.palette.primary.main,
            // color: theme.palette.primary.main,

        }
    }

    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // Forms
    const [phone, setPhone] = useState(form.phone);
    const [name, setName] = useState(form.name);
    const [surname, setSurname] = useState(form.surname);
    const [email, setEmail] = useState(form.email);
    const [kvkkPermission, setKvkkPermission] = useState(form.kvkkPermission);
    const [permission, setPermission] = useState(form.permission);
    const [phonePermission, setPhonePermission] = useState(form.phonePermission);
    const [smsPermission, setSmsPermission] = useState(form.smsPermission);
    const [emailPermission, setEmailPermission] = useState(form.emailPermission);

    // Form error states
    const [phoneError, setPhoneError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [surnameError, setSurnameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [permissionError, setPermissionError] = useState(false);
    const [kvkkPermissionError, setKvkkPermissionError] = useState(false);

    const [nextButtonColor, setNextButtonColor] = useState('inherit');

    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSteps',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'step-3',
            'formStepNumber': 'step-3',
            'vehicleId': portLogin ? vehicle.id : "",

            'vehicleModel': portLogin ? vehicle.modelName : form.vehicleModel,

            'dealerName': form.dealer.name,
            'dealerId': form.dealer.id


        });

    }, [])




    // On permission change
    useEffect(() => {
        if (!portLogin) {
            if ((phonePermission || smsPermission || emailPermission) && kvkkPermission) {
                setNextButtonColor('secondary');
            } else {
                setNextButtonColor('inherit');
            }

            if (!permission) {
                setPhonePermission(false)
                setSmsPermission(false)
                setEmailPermission(false)
            }
        }
        else {
            setNextButtonColor('secondary');
        }

    }, [permission, phonePermission, smsPermission, emailPermission, kvkkPermission])

    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])

    // Previous step
    function handleBackButton() {
        dispatch(previousStep())
    }

    // Next step
    function handleNextStep() {
        if (loading) {
            return
        }

        // Form validation
        let error = false;
        if (!phone || !phone.match(/(\()*[0-9]{2}(\))*\s*[0-9]{3}\s*[0-9]{3}\s*[0-9]{2}\s*[0-9]{2}/g)) {
            error = true
            setPhoneError(true)
        }
        if (!name) {
            error = true
            setNameError(true)
        }
        if (!surname) {
            error = true
            setSurnameError(true)
        }
        if (!(kvkkPermission) && !portLogin) {
            error = true
            setKvkkPermissionError(true)
        }
        if (!(phonePermission || smsPermission || emailPermission) && !portLogin) {
            error = true
            setPermissionError(true)
        }

        if (!email || !email.match(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)) {
            error = true
            setEmailError(true)
        }

        // Don't proceed if there is an error 
        if (!error) {

            // If customer proceeded without port login, send sms to verify its phone 
            if (!portLogin) {

                // Set loading
                dispatch(setLoading(true))

                const body = {
                    vehicleInfo: form.vehicleInfo,
                    km: form.km,

                    // Renaming some fields for request
                    notes: form.appointmentRequests,
                    dealerId: form.dealer.id,
                    appointmentDate: form.timeSlot.date,
                    timeSlot: form.slot,
                    vehicleModel: form.vehicleModel,
                    requestValeService: form.vale,

                    phone: phone.replace(/[^0-9]/g, ''),
                    name,
                    surname,
                    email,
                    kvkkPermission,
                    permission,
                    phonePermission,
                    smsPermission,
                    emailPermission,
                    utmCampaign: utmValues.utmCampaign,
                    utmMedium: utmValues.utmMedium,
                    utmSource: utmValues.utmSource,
                    origin: utmValues.origin,
                    campaign: utmValues.campaign,
                    platform: utmValues.platform

                }
                // Send sms to customer and create appointment
                createAppointment(body)
                    .then(appointment => {

                        // Save info to redux and proceed
                        dispatch(setCustomerInfo({
                            phone,
                            name,
                            surname,
                            email,
                            kvkkPermission,
                            permission,
                            phonePermission,
                            smsPermission,
                            emailPermission
                        }))

                        // Set appointment
                        dispatch(setAppointment(appointment))

                        dispatch(nextStep())

                    })
                    .catch(e => {
                        console.error(e)
                        dispatch(showError(t('UNKNOWN_ERROR')))
                    })
                    .finally(() => {
                        dispatch(setLoading(false))
                    })
            }
            // Phone already verified at login, go next step 
            else {

                // Save info to redux and proceed
                dispatch(setCustomerInfo({
                    phone,
                    name,
                    surname,
                    email,
                    permission,
                    phonePermission,
                    smsPermission,
                    emailPermission
                }))
                dispatch(nextStep())
            }
        }
    }

    function getCardContent() {
        return (
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant='h6' color='textPrimary' align='center'>
                        {t('personalInfo')}
                    </Typography>
                </Grid>
                <Box m={1} />
                <Grid item container xs={12} sm={12} md={12}>
                    <form className={styles.formRoot} noValidate autoComplete="off">
                        <Grid container spacing={spacingForm} style={{ width: 'auto' }}>
                            {/* Name */}
                            <Grid item xs={12}>
                                <CustomFormLabel content={t('enterName')} />
                                <CustomTextField
                                    style={{ marginTop: '5px' }}
                                    error={nameError}
                                    portLogin={portLogin}
                                    errorText={t('nameError')}
                                    fullWidth
                                    required
                                    variant='outlined'
                                    value={name}
                                    onChange={e => {
                                        setName(e.target.value);
                                        if (e.target.value) {
                                            setNameError(false)
                                        }
                                    }}
                                />
                            </Grid>

                            {/* Surname */}
                            <Grid item xs={12}>
                                <CustomFormLabel content={t('enterSurname')} />
                                <CustomTextField
                                    style={{ marginTop: '5px' }}
                                    error={surnameError}
                                    errorText={t('surnameError')}
                                    portLogin={portLogin}
                                    fullWidth
                                    required
                                    variant='outlined'
                                    value={surname}
                                    onChange={e => {
                                        setSurname(e.target.value);
                                        if (e.target.value) {
                                            setSurnameError(false)
                                        }
                                    }}
                                />
                            </Grid>

                            {/* Phone */}
                            <Grid item xs={12}>
                                <CustomFormLabel content={t('enterPhone')} />
                                <PhoneInput
                                    style={{ marginTop: '5px' }}
                                    state={phoneError ? 'error' : ''}
                                    error={phoneError}
                                    portLogin={portLogin}
                                    helperText={phoneError ? t('phoneError') : null}
                                    fullWidth
                                    required
                                    variant='outlined'
                                    value={phone}
                                    onChange={e => {
                                        setPhone(e.target.value);
                                        if (e.target.value) {
                                            setPhoneError(false)
                                        }
                                    }}
                                    mask='(\90) 599 999 99 99'
                                />
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12}>
                                <CustomFormLabel content={t('enterEmail')} />
                                <CustomTextField
                                    style={{ marginTop: '5px' }}
                                    error={emailError}
                                    errorText={t('emailError')}
                                    portLogin={portLogin}
                                    fullWidth
                                    required
                                    variant='outlined'
                                    value={email}
                                    type='email'
                                    onChange={e => {
                                        setEmail(e.target.value);
                                        if (e.target.value) {
                                            setEmailError(false)
                                        }
                                    }}
                                />
                            </Grid>

                            {/* Permissions */}
                            {
                                !portLogin ?
                                    <Grid item xs={12}>
                                        {
                                            kvkkPermissionError &&
                                            <Box alignItems='center'>
                                                <Typography variant='body2' color='error' style={{ fontSize: 12 }}>
                                                    {t('kvkkError')}
                                                </Typography>
                                            </Box>
                                        }
                                        <Box display='flex' alignItems='center' ml='-11px'>
                                            <Checkbox
                                                checked={kvkkPermission}
                                                onChange={e => {
                                                    setKvkkPermission(e.target.checked)
                                                    if (e.target.checked) setKvkkPermissionError(false)
                                                }}
                                                color='default'
                                                sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                            />
                                            <Typography variant='body1' color='textPrimary'>
                                                KVKK uyarınca kişisel verilerimin <a href={WEB_LINKS.KVKK} className={styles.link} target="_blank" rel="noreferrer" >Açık Rıza ve Aydınlatma Metni</a>’nde belirtilen hususlar kapsamında işlenmesini ve aktarılmasına onay verdiğimi kabul ediyorum.
                                            </Typography>

                                        </Box>

                                        {/* Permission */}
                                        <Box display='flex' alignItems='center' ml='-11px'>
                                            <Checkbox
                                                checked={permission}
                                                onChange={e => {
                                                    // Don't let be unchecked
                                                    setPermission(e.target.checked)
                                                }}
                                                color='default'
                                                sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                            />
                                            <Typography variant='body1' color='textPrimary'>{t('permission')}</Typography>
                                        </Box>
                                        {
                                            permissionError &&
                                            <Box alignItems='center'>
                                                <Typography variant='body2' color='error' style={{ fontSize: 12 }}>{`${t('permissionError')}`}</Typography>
                                            </Box>
                                        }

                                        <Grid item container xs={12} direction="row" wrap="noWrap" style={{ display: "flex", marginLeft: "32px" }}>

                                            {/* Phone Permission */}
                                            <Box display='flex' alignItems='center' ml='-11px' style={{ marginRight: "20px" }}>
                                                <Checkbox
                                                    disabled={!permission}
                                                    checked={phonePermission}
                                                    onChange={e => {
                                                        setPhonePermission(e.target.checked)
                                                        if (e.target.checked) setPermissionError(false)
                                                    }}
                                                    color='default'
                                                    sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                                />
                                                <Typography variant='body1' style={{ fontSize: xsDown ? '1em' : undefined }} color='textPrimary'>{t('phonePermission')}</Typography>
                                            </Box>

                                            {/* Sms Permission */}
                                            <Box display='flex' alignItems='center' ml='-11px' style={{ marginRight: "20px" }}>
                                                <Checkbox
                                                    disabled={!permission}
                                                    checked={smsPermission}
                                                    onChange={e => {
                                                        setSmsPermission(e.target.checked)
                                                        if (e.target.checked) setPermissionError(false)
                                                    }}
                                                    color='default'
                                                    sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                                />
                                                <Typography variant='body1' style={{ fontSize: xsDown ? '1em' : undefined }} color='textPrimary'>{t('smsPermission')}</Typography>
                                            </Box>

                                            {/* Email Permission */}
                                            <Box display='flex' alignItems='center' ml='-11px' style={{ marginRight: "20px" }}>
                                                <Checkbox
                                                    disabled={!permission}
                                                    checked={emailPermission}
                                                    onChange={e => {
                                                        setEmailPermission(e.target.checked)
                                                        if (e.target.checked) setPermissionError(false)
                                                    }}
                                                    color='default'
                                                    sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                                />
                                                <Typography variant='body1' style={{ fontSize: xsDown ? '1em' : undefined }} color='textPrimary'>{t('emailPermission')}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid> :
                                    <Grid item xs={12} ml='-11px' style={{ marginRight: "20px" }}>
                                        <Typography variant='body1' color='textPrimary'>{t('loginPortUserInfo')}</Typography>
                                    </Grid>
                            }
                        </Grid>
                    </form>
                </Grid>

            </Grid>
        )
    }

    function getCardActions() {
        return (
            <Box display='flex' justifyContent='space-between'>
                <Button
                    variant="contained"
                    sx={styles.button}
                    onClick={handleBackButton}
                    style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none' }}
                >
                    {t('backButton')}
                </Button>
                <Button variant="contained" color={nextButtonColor} style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none', marginLeft: '5px' }} onClick={handleNextStep}>
                    {t('nextButton')}
                </Button>
            </Box>
        )
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={getCardContent()}
            action={getCardActions()}
        />
    )

}

// Connect redux and translation
export default FunctionalComponent